<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.312"
    height="17.734"
    viewBox="0 0 22.312 17.734"
  >
    <g transform="translate(-1098.927 -581.907)">
      <path
        d="M1110.621,599.641a10.136,10.136,0,0,1-3.9-.682c-3.1-1.33-6.077-4.951-6.643-5.857a18.242,18.242,0,0,1-1.121-2.376.5.5,0,0,1-.03-.233c.006-.056.654-5.6,5.633-6.395a2.588,2.588,0,0,1,2.1.595,2.768,2.768,0,0,1,.754,2.246,1.891,1.891,0,0,0,1.791,1.992,2.145,2.145,0,0,0,.241,0,1.268,1.268,0,0,1,1.384,1.112,1.593,1.593,0,0,0,.211.49,1.964,1.964,0,0,0,1.427.491.78.78,0,0,0,.685-.418,5.243,5.243,0,0,0,.538-2.354c.035-.429.078-.937.154-1.576.188-1.608.539-3.369,1.7-4.242a2.91,2.91,0,0,1,2.318-.466c3.177.538,3.378,5.853,3.363,7.47a12.9,12.9,0,0,1-3.459,8.037C1116.317,598.845,1113.368,599.641,1110.621,599.641Zm-10.682-9.158a17.4,17.4,0,0,0,1,2.109c.5.794,3.337,4.229,6.178,5.447,2.811,1.21,8.022.54,9.955-1.273a11.875,11.875,0,0,0,3.166-7.367c.024-2.758-.624-6.126-2.531-6.448a1.927,1.927,0,0,0-1.552.28c-.868.65-1.157,2.244-1.312,3.559-.073.624-.115,1.122-.149,1.542a6.117,6.117,0,0,1-.646,2.73,1.78,1.78,0,0,1-1.489.956,2.852,2.852,0,0,1-2.31-.884,2.47,2.47,0,0,1-.368-.8c-.129-.415-.134-.407-.383-.411a2.478,2.478,0,0,1-.337,0,2.894,2.894,0,0,1-2.74-3.036,1.83,1.83,0,0,0-.439-1.47,1.652,1.652,0,0,0-1.287-.334C1100.818,585.712,1100.05,589.728,1099.939,590.483Z"
        fill="#777"
      />
      <path
        d="M1111.719,598.132a14.145,14.145,0,0,1-5.71-1.411c-2.755-1.262-6.447-7.585-6.6-7.854l.866-.5c.036.064,3.687,6.317,6.154,7.448,2.844,1.3,5.521,1.649,7.542.972,2.256-.757,4.713-4.6,4.833-6.8a54.445,54.445,0,0,0-.436-7.015l.992-.127a55.311,55.311,0,0,1,.443,7.172c-.142,2.626-2.841,6.825-5.514,7.721A8.013,8.013,0,0,1,1111.719,598.132Z"
        fill="#777"
      />
      <rect
        width="3.273"
        height="1"
        transform="translate(1108.193 593.167) rotate(-54.944)"
        fill="#777"
      />
      <rect
        width="2.989"
        height="1.001"
        transform="matrix(0.375, -0.927, 0.927, 0.375, 1110.048, 594.083)"
        fill="#777"
      />
      <rect
        width="3.17"
        height="1"
        transform="translate(1112.143 594.637) rotate(-86.864)"
        fill="#777"
      />
      <rect
        width="0.999"
        height="3.503"
        transform="translate(1113.225 591.115) rotate(-17.541)"
        fill="#777"
      />
    </g>
  </svg>
</template>
